module.exports = __webpack_public_path__ + "img/wedding-rings-bronze.02db53fb.svg";